//WE.Flow.Html.Contracts.Manifests.Components.MenuManifest
import { ToolbarItemManifest } from "./ToolbarItemManifest";

export class MenuManifest {
    isMenu: boolean = false;
    isAutoStart: boolean = false;
    id: string = "";
    name: string = "";
    defaultParameters: any = null;
    toolbarItem: ToolbarItemManifest = null;
    viewUrl: string = "";
    namespace: string = "";
    viewModelId: string = "";
    reuseInstance: boolean = false;
    useFormValidation: boolean = false;
    useValidationV3: boolean = false;
    cssUrls: string[] = null;
    moduleRoles: string[] = null;
    tags: string[] = null;
}
